import { ReactNode, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import Modal from '@components/Modal/Modal';
import modalStyles from '@components/Modal/Modal.styles';
import styles from '@components/StatutoryConsumerProtectionNotice/StatutoryConsumerProtectionNotice.styles';
import { getLegalGuaranteeNoticeUrl } from '@config/index';
const DynamicModalRootPortal = dynamic(() => import('@components/ModalRootPortal/ModalRootPortal'), {
  ssr: false
});
type PropsType = {
  renderTrigger?: (open: () => void, title: string) => ReactNode;
};
const StatutoryConsumerProtectionNotice = ({
  renderTrigger
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const {
    locale
  } = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const url = getLegalGuaranteeNoticeUrl(locale);
  const title = t('summaryInfo.statutoryConsumerProtection');
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!isMounted || !url) {
    return null;
  }
  const open = () => setIsOpen(true);
  return <>
      {renderTrigger ? renderTrigger(open, title) : <Button variant="link" cy="StatutoryConsumerProtection" addSx={styles.button} size="small" onClick={open}>
          <div>{title}</div>
          <Icon icon="ChevronRight" size="24px" ariaHidden />
        </Button>}
      <DynamicModalRootPortal>
        <Modal active={isOpen} closeFunc={setIsOpen} heading={title} closeOnOutsideClick pdfLayout>
          {isOpen && <iframe title={title} src={url} sx={modalStyles.pdfFrame} />}
        </Modal>
      </DynamicModalRootPortal>
    </>;
};
export default StatutoryConsumerProtectionNotice;